module.exports = __webpack_public_path__ + "static/media/yoomoney.763a9e41.png";